/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */

import type JSZip from "jszip";
import { loadAsync } from "jszip";

function readStreamAsBuffer(stream: NodeJS.ReadableStream): Promise<Buffer> {
	return new Promise((resolve, reject) => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const data: any[] = [];
		stream.on("data", (chunk) => {
			data.push(chunk);
		});
		stream.on("close", () => {
			resolve(Buffer.concat(data));
		});
		stream.on("error", (error) => {
			reject(error);
		});
	});
}

export async function unzipStream(stream: NodeJS.ReadableStream): Promise<JSZip> {
	return loadAsync(await readStreamAsBuffer(stream));
}
